import React from 'react';
import ReactDOM from 'react-dom';
import {StoreProvider} from 'easy-peasy';
import ReactGA from 'react-ga';

import store from './configureStore';
import registerServiceWorker from './serviceWorker';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {Routes} from './routes';
import {theme} from './styles/custom-theme-style';
import './index.css';
import 'basscss/css/basscss.min.css'
import config from './config';

ReactGA.initialize(config.GATrackingCode);

const customTheme = createMuiTheme(theme);

ReactDOM.render(
  <div className="App">
    <StoreProvider store={store}>
      <MuiThemeProvider theme={customTheme}>
        <Routes />
      </MuiThemeProvider>
    </StoreProvider>
  </div>,
  document.getElementById('root')
);

// Learn more about service workers in CRA: http://bit.ly/CRA-PWA
registerServiceWorker();
